import React from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './home.css';
import './salesquote.css';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import useFetch from '../Components/UseFetch';
import { Buffer } from 'buffer';
import { customers } from '../HelperFx/datalinks';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import verifyToken from '../HelperFx/verifyJwt.js';

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

const formatDate = (dateString) => {
  if (!dateString) return "";
  const parts = String(dateString).split('-');
  if (parts.length === 3) {
    const year = parts[0];
    const month = parts[1].padStart(2, '0');
    const day = parts[2].padStart(2, '0'); 
    const date = new Date(`${month}/${day}/${year}`);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split('T')[0];
  }
  return "";
};

const ProfilePage = () => {
    const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
    const jwttoken = sessionStorage.getItem('authToken');
    const { custName } = verifyToken(jwttoken) || {};

    const customerUrl = custName
        ? `${REACT_DATA_URL}${customers}?${REACT_APP_COMPANY_URL}&$filter=no eq '${custName}'`
        : null;
    const { data: customer } = useFetch(customerUrl, token);
    const CustomerInformation = customer?.value?.[0] || null;

    return (
        <div className="Home">
            <Nav />
            <div className="dash-main">
                <div className="squote">
                    <div className="firsttab">
                        <IconButton component={Link} to="/home">
                        <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
                        </IconButton>
                        <span>User Profile</span>
                    </div>
                    {/* Profile Information Card */}
                    <div className="customerProfile">
                        <span className="fs-5 cust-details">Profile Details</span>
                        {CustomerInformation ? (
                            <div className="cust-overview">
                                <div className="cust-col-detail">
                                    <div className="field-name">Name:</div>
                                    <div className="field-value">{CustomerInformation.name}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">TIN Number:</div>
                                    <div className="field-value">{CustomerInformation.vatRegistrationNo}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Phone No.:</div>
                                    <div className="field-value">{CustomerInformation.phoneNo ? `+${CustomerInformation.phoneNo}` : ""}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Address 1:</div>
                                    <div className="field-value">{CustomerInformation.address}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Email Address:</div>
                                    <div className="field-value">{CustomerInformation.eMail}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Payment Terms:</div>
                                    <div className="field-value">{CustomerInformation.paymentTermsCode}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Balance Due:</div>
                                    <div className="field-value">{CustomerInformation.balanceLCY}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Currency:</div>
                                    <div className="field-value">{CustomerInformation.currencyCode}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Tax Group:</div>
                                    <div className="field-value">{CustomerInformation.vatBusPostingGroup}</div>
                                </div>
                                <div className="cust-col-detail">
                                    <div className="field-name">Ship To:</div>
                                    <div className="field-value">{CustomerInformation.shipTo}</div>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {/* Recent Activities Section */}
                    <div className="recent-activities">
                        <h2>Recent Activities</h2>
                        <DataTable
                            columns={[
                                { name: 'Date', selector: row => formatDate(row.date), sortable: true },
                                { name: 'Activity', selector: row => row.activity, sortable: true },
                                { name: 'Details', selector: row => row.details, sortable: true }
                            ]}
                            data={[
                                { date: '2023-10-01', activity: 'Login', details: 'User logged in' },
                                { date: '2023-10-02', activity: 'Order Placed', details: 'Order #12345 placed' },
                                { date: '2023-10-03', activity: 'Payment Received', details: 'Payment for invoice #67890 received' }
                            ]}
                            pagination
                        />
                    </div>

                    {/* Additional Information Section */}
                    <div className="additional-info">
                        <h2>Additional Information</h2>
                        <div className="info-grid">
                            <div className="info-item">
                                <label>Customer Since:</label>
                                <span>{formatDate(CustomerInformation?.customerSince)}</span>
                            </div>
                            <div className="info-item">
                                <label>Last Order Date:</label>
                                <span>{formatDate(CustomerInformation?.lastOrderDate)}</span>
                            </div>
                            <div className="info-item">
                                <label>Total Orders:</label>
                                <span>{CustomerInformation?.totalOrders}</span>
                            </div>
                            <div className="info-item">
                                <label>Total Spend:</label>
                                <span>{CustomerInformation?.totalSpend}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ProfilePage;